import { z } from 'zod';
// Esqueleto comum a toda tabela sincronizável (spec §4).
export const Base = z.object({
    id: z.uuid(),
    user_id: z.uuid(),
    // Relógio do aparelho: árbitro do last-write-wins. Só ISO com sufixo Z:
    // o PostgREST devolve "+00:00" com microssegundos, e o mapeamento do sync
    // (etapa 4) normaliza para Z antes de qualquer parse. Comparar strings
    // só é válido com um formato único.
    updated_at: z.iso.datetime(),
    // Relógio do servidor: cursor de pull. Nulo enquanto nunca sincronizou.
    server_updated_at: z.iso.datetime().nullable(),
    deleted: z.boolean(),
});
export const TIPOS_DE_PERFIL = [
    'publicador',
    'nao_batizado',
    'auxiliar',
    'regular',
    'especial',
    'missionario',
];
const META_PADRAO = {
    publicador: 0,
    nao_batizado: 0,
    auxiliar: 15,
    regular: 50,
    especial: 100,
    missionario: 100,
};
export const Perfil = Base.extend({
    tipo: z.enum(TIPOS_DE_PERFIL),
    meta_horas_mes: z.number().int().min(0).optional(),
    nome_exibicao: z.string(),
}).transform((p) => ({
    ...p,
    meta_horas_mes: p.meta_horas_mes ?? META_PADRAO[p.tipo],
}));
export const STATUS_PESSOA = [
    'interessado',
    'revisita',
    'estudo',
    'nao_visitar',
];
export const Pessoa = Base.extend({
    nome: z.string(),
    apelido: z.string(),
    telefone: z.string(),
    endereco: z.string(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    idioma: z.string(),
    status: z.enum(STATUS_PESSOA),
    tags: z.array(z.string()),
    nota: z.string(),
    casa_id: z.uuid().nullable(),
    proxima_visita_em: z.iso.datetime().nullable(),
});
export const RESULTADOS = [
    'nao_estava',
    'conversamos',
    'nao_interessado',
    'deixei_publicacao',
    'revisita',
    'estudo',
];
export const CANAIS = [
    'porta',
    'telefone',
    'carta',
    'carrinho',
    'informal',
];
export const Visita = Base.extend({
    pessoa_id: z.uuid().nullable(),
    casa_id: z.uuid().nullable(),
    em: z.iso.datetime(),
    resultado: z.enum(RESULTADOS),
    canal: z.enum(CANAIS),
    nota: z.string(),
    publicacao: z.string(),
    proxima_acao: z.string(),
});
export const Estudo = Base.extend({
    pessoa_id: z.uuid(),
    publicacao: z.string(),
    licao: z.string(),
    // Dia da semana 0–6 (domingo = 0) e hora "HH:MM"; nulos quando não há
    // horário fixo.
    dia_da_semana: z.number().int().min(0).max(6).nullable(),
    hora: z
        .string()
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
        .nullable(),
    iniciado_em: z.iso.datetime(),
    encerrado_em: z.iso.datetime().nullable(),
});
export const CATEGORIAS = [
    'campo',
    'carrinho',
    'telefone',
    'cartas',
    'credito',
];
export const SUBCATEGORIAS = ['ldc', 'betel', 'escola', 'socorro'];
export const Sessao = Base.extend({
    inicio: z.iso.datetime(),
    fim: z.iso.datetime().nullable(),
    categoria: z.enum(CATEGORIAS),
    subcategoria: z.enum(SUBCATEGORIAS).nullable(),
    nota: z.string(),
});
export const Mes = Base.extend({
    ano: z.number().int().min(2000).max(2100),
    mes: z.number().int().min(1).max(12),
    participou: z.boolean().default(false),
    estudos: z.number().int().min(0).default(0),
    horas_minutos: z.number().int().min(0).default(0),
    creditos_minutos: z.number().int().min(0).default(0),
    observacao: z.string().default(''),
    enviado_em: z.iso.datetime().nullable().default(null),
    transporte_minutos: z.number().int().min(0).max(59).default(0),
    // Quando true, o cálculo automático não sobrescreve os totais.
    sobrescrito: z.boolean().default(false),
});
export const Territorio = Base.extend({
    nome: z.string(),
    descricao: z.string(),
    cartao_asset_id: z.string().nullable(),
    recebido_em: z.iso.datetime().nullable(),
    devolvido_em: z.iso.datetime().nullable(),
});
export const ESTADOS_CASA = [
    'nunca',
    'nao_estava',
    'visitada',
    'nao_visitar',
];
export const Casa = Base.extend({
    territorio_id: z.uuid(),
    rua: z.string(),
    numero: z.string(),
    complemento: z.string(),
    ordem: z.number().int(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    estado: z.enum(ESTADOS_CASA),
    ultima_visita_em: z.iso.datetime().nullable(),
});
//# sourceMappingURL=entidades.js.map